import type { FC } from 'react';
import { CommonButton } from '@shared/ui';
import { AuthForm } from '@src/modules/Authentication/AuthFrom';
import CustomInput from '@src/modules/Authentication/CustomInput';
import { ModalError } from '@src/modules/Authentication/frames/modal-error';
import { PasswordHint } from '@src/modules/Authentication/frames/password-hint';
import * as st from './styles.module.scss';

interface Props {
  model: any;
}

export const ResetPassStep: FC<Props> = ({ model }) => {
  const errorMessage =
    model.errorsPass?.password?.message ||
    model.errorsPass?.passwordRepeat?.message ||
    model.errorsPass?.root?.message;
  return (
    <AuthForm onSubmit={model.submitForm((data: any) => model.confirmForm(data))}>
      <div className={st.passwordBlock}>
        <CustomInput
          tabindex={0}
          type="password"
          label="Пароль"
          name="password"
          control={model.passwordControl}
          error={model.errorsPass?.password}
          disabled={model.isLoading}
          showPassword={model.showPassword}
          onChange={model?.cleanPasswordError}
          setValue={() => {
            model.setShowPassword(!model.showPassword);
          }}
        />

        <CustomInput
          tabindex={0}
          type="password"
          label="Повторите пароль"
          name="passwordRepeat"
          control={model.passwordControl}
          error={model.errorsPass?.passwordRepeat}
          disabled={model.isLoading}
          showPassword={model.showPasswordRepeat}
          onChange={model?.cleanPasswordError}
          setValue={() => {
            model.setShowPasswordRepeat(!model.showPasswordRepeat);
          }}
        />
        <PasswordHint className={st.hint} />
      </div>

      {errorMessage ? (
        <ModalError error={errorMessage} />
      ) : (
        <CommonButton tabIndex={3} type="submit" disabled={model.isLoading}>
          Готово
        </CommonButton>
      )}
    </AuthForm>
  );
};
